module.exports = __webpack_public_path__ + "img/socio9.1e83f311.png";